import Vue from "vue";
import axios from "axios";
import router from "@/router";

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios.create({
      baseURL: process.env.VUE_APP_URL,
      // headers: {
      //     "Authorization" : "abc123"
      // }
    });
    Vue.prototype.$http.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && 401 === error.response.status) {
          //return (window.location = "/login");
          return router.push("/inicio");
        } else {
          return Promise.reject(error);
        }
      }
    );
    // Vue.prototype.$http.interceptors.request.use( config => {
    //     console.log(config.method)
    //     return config
    // }, error => Promise.reject(error))

    // Vue.prototype.$http.interceptors.request.use( config => {
    //     console.log('outro interceptor de request')
    //     return config
    // }, error => Promise.reject(error))

    // Vue.prototype.$http.interceptors.response.use( config => {
    //     // const array = []
    //     // for(let chave in config.data){
    //     //     array.push( { id: chave, ...config.data[chave]})
    //     // }

    //     // config.data = array
    //     return config
    // }, error => Promise.reject(error))
  },
});
